import { render, staticRenderFns } from "./tabbed_graph_view.vue?vue&type=template&id=ea4925fe&scoped=true&"
import script from "./tabbed_graph_view.vue?vue&type=script&lang=js&"
export * from "./tabbed_graph_view.vue?vue&type=script&lang=js&"
import style0 from "./tabbed_graph_view.vue?vue&type=style&index=0&id=ea4925fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4925fe",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTab,VTabItem,VTabs,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea4925fe')) {
      api.createRecord('ea4925fe', component.options)
    } else {
      api.reload('ea4925fe', component.options)
    }
    module.hot.accept("./tabbed_graph_view.vue?vue&type=template&id=ea4925fe&scoped=true&", function () {
      api.rerender('ea4925fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/results-pages/tabs/tabbed_graph_view.vue"
export default component.exports